import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IClientIdValidationRequest {
  clientId: string;
}

interface IClientIdValidationResponse {
  status?: boolean;
  message?: string;
  data?: {
    username?: string;
    firstName?: string;
    lastName?: string;
    reference?: string;
  };
  errors?: IApiResponseError[];
}

const initialState: IApiState<IClientIdValidationResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const clientIdValidationAsync = createAsyncThunk(
  'clientId/validation',
  async (values: IClientIdValidationRequest, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `BearerToken ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.post(
        'bet9ja/deposits/customer-validation',
        values,
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IClientIdValidationResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const clientIdValidationSlice = createSlice({
  name: 'clientId/validation',
  initialState,
  reducers: {
    resetClientIdValidation(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clientIdValidationAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(clientIdValidationAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IClientIdValidationResponse;
      })
      .addCase(clientIdValidationAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IClientIdValidationResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetClientIdValidation } = clientIdValidationSlice.actions;

export default clientIdValidationSlice.reducer;
